if (window.quickAddSizeExecuted == false) {
  window.quickAddSizeExecuted = true;
  const fetchCardProduct = (productCard, productID, productColor) => {
    fetch(`/products/${productID}.js`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    })
      .then((response) => response.json())
      .then((product) => {
        if (product.variants) {
          if ((productColor == true || productColor == false) && productCard.querySelector('.card__variants-sizes'))
            productCard.querySelector('.card__variants-sizes').remove();
          if (productCard.querySelector('.card__variants-sizes')) return;

          const container = document.createElement('div');
          container.className = 'card__variants-sizes';
          product.variants.forEach((variant) => {
            const button = document.createElement('button');
            button.className = 'card__size';
            button.textContent = variant.option1;
            if (!variant.available) button.disabled = true;
            button.dataset.variantId = variant.id;
            button.addEventListener('click', addToCart);
            container.appendChild(button);
          });
          if (window.matchMedia('(min-width: 750px)').matches) {
            const cardMedia = productCard.querySelector('.card__media');
            cardMedia.insertAdjacentElement('afterend', container);
          } else {
            if (productColor) return;

            const card = productCard.querySelector('.card');
            const cardFakeButton = document.createElement('button');
            const productFormHeader = document.createElement('div');
            const cardColors = productCard.querySelector('.card-colors')?.cloneNode(true);

            const cardClose = document.createElement('button');

            productFormHeader.className = 'card__size-header';

            cardFakeButton.innerText = window.variantStrings.selectSize;
            cardFakeButton.className = 'card__size-button button button--full-width button--primary';

            cardClose.className = 'card__sizes-close link full-unstyled-link';
            cardClose.innerHTML =
              '<svg class="icon icon-close" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.560981 10L0 9.43902L4.43902 5L0 0.560981L0.560981 0L5 4.43902L9.43902 0L10 0.560981L5.56098 5L10 9.43902L9.43902 10L5 5.56098L0.560981 10Z" fill="currentColor"/></svg>';

            //container.appendChild(cardFakeButton);
            if (cardColors != undefined) productFormHeader.appendChild(cardColors);
            productFormHeader.appendChild(cardClose);
            container.insertBefore(productFormHeader, container.firstChild);

            if (card.closest('.scroll-trigger.animate--slide-in'))
              card.closest('.scroll-trigger.animate--slide-in').classList.remove('scroll-trigger', 'animate--slide-in');
            if (card.closest('li')) {
              card.closest('li').classList.add('open-sizes');
            } else {
              card.closest('.card-wrapper').parentNode.classList.add('open-sizes');
            }
            if (card.closest('.shopify-section')) card.closest('.shopify-section').classList.add('open-sizes');

            card.insertAdjacentElement('afterend', container);

            cardClose.addEventListener('click', () => {
              if (card.closest('li')) {
                card.closest('li').classList.remove('open-sizes');
              } else {
                card.closest('.card-wrapper').parentNode.classList.remove('open-sizes');
              }
              if (card.closest('.shopify-section')) card.closest('.shopify-section').classList.remove('open-sizes');
              if (productCard.querySelector('.card__variants-sizes')) {
                productCard.querySelector('.card__variants-sizes').remove();
              }
            });

            const cardVariantsSizes = document.querySelector('.card__variants-sizes');

            document.addEventListener('click', handleClickOutside);

            cardVariantsSizes.addEventListener('click', (event) => {
              event.stopPropagation();
            });

            function handleClickOutside(event) {
              if (!cardVariantsSizes.contains(event.target) && cardClose) {
                cardClose.click();
              }
            }

            const productColor2 = productCard.querySelector('.card__variants-sizes').querySelectorAll('.color-dot');

            productColor2.forEach((color) => {
              color.addEventListener('click', () => {
                fetchCardProductColors(color, productCard, false);
              });
            });
          }
          setTimeout(() => {
            productCard.classList.add('has-sizes');
          }, 100);
        }
      });
  };

  const addToCart = (event) => {
    event.preventDefault();
    const variantId = event.target.dataset.variantId;
    let gridItem = '';
    if (event.target.closest('.grid__item')) {
      gridItem = event.target.closest('.grid__item');
    } else if (event.target.closest('.collage__item')) {
      gridItem = event.target.closest('.collage__item');
    } else {
      gridItem = event.target.closest('.predictive-search__list-item');
    }
    const preorder = gridItem.querySelector('.product-card-wrapper').getAttribute('data-preorder');
    const index = gridItem.getAttribute('data-index-list');
    const page = gridItem.getAttribute('data-list-page');
    const model = gridItem.getAttribute('data-product-model')?.replace('*', '');
    const stock = gridItem.getAttribute('data-product-score-stock');
    const scoreStock = calcularScoreStock(gridItem.getAttribute('data-product-score-stock'));
    const availableSizes = getAvailableAndUnavailableSizes(gridItem.getAttribute('data-product-score-stock')).available;
    const unavailableSizes = getAvailableAndUnavailableSizes(
      gridItem.getAttribute('data-product-score-stock')
    ).unavailable;

    const url = document.location.href;
    const urlObj = new URL(url);

    const getParamValues = (param) => {
      return [...new URLSearchParams(urlObj.search).entries()]
        .filter(([key, value]) => key.includes(param))
        .map(([key, value]) => value);
    };

    const color = getParamValues('filter.v.option.color');
    const size = getParamValues('filter.v.option.talla');
    const minPrice = urlObj.searchParams.get('filter.v.price.gte');
    const maxPrice = urlObj.searchParams.get('filter.v.price.lte');
    const orderBy = urlObj.searchParams.get('sort_by');

    let filters = [];

    if (color.length > 0) filters.push(`color:${color.join(',')}`);
    if (size.length > 0) filters.push(`talla:${size.join(',')}`);
    if (minPrice !== null || maxPrice !== null) {
      let priceRange = `${minPrice || '0'}-${maxPrice || '∞'}`;
      filters.push(`precio:${priceRange}`);
    }
    if (orderBy !== null) filters.push(`ordenar por:${orderBy}`);

    const viewListId = `${document.title.split(' | ')[0]}|F:${filters.length > 0 ? filters.join(',') : 'N/A'}`;

    const eventTarget = event.target;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              'PRE-ORDER': preorder,
              _analytics: {
                modelo_articulo: model,
                stock: stock,
                score_stock: scoreStock,
                available_sizes: availableSizes,
                unavailable_sizes: unavailableSizes,
                item_list_name: viewListId,
                item_list_id: document.title.split(' | ')[0],
                promotion_name: sessionStorage.getItem('promotion_name') || '',
                promotion_id: sessionStorage.getItem('promotion_id') || '',
              },
            },
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        openCart(data, eventTarget);
        const cart = document.querySelector('cart-notification');
        const cartRecommendations = cart.querySelector('product-recommendations');
        if (cartRecommendations) {
          cartRecommendations.setAttribute('data-product-id', data.items[0].product_id);
        }
        const item = data.items[0];

        const url = document.location.href;
        const urlObj = new URL(url);

        const getParamValues = (param) => {
          return [...new URLSearchParams(urlObj.search).entries()]
            .filter(([key, value]) => key.includes(param))
            .map(([key, value]) => value);
        };

        const color = getParamValues('filter.v.option.color');
        const size = getParamValues('filter.v.option.talla');
        const minPrice = urlObj.searchParams.get('filter.v.price.gte');
        const maxPrice = urlObj.searchParams.get('filter.v.price.lte');
        const orderBy = urlObj.searchParams.get('sort_by');

        let filters = [];

        if (color.length > 0) filters.push(`color:${color.join(',')}`);
        if (size.length > 0) filters.push(`talla:${size.join(',')}`);
        if (minPrice !== null || maxPrice !== null) {
          let priceRange = `${minPrice || '0'}-${maxPrice || '∞'}`;
          filters.push(`precio:${priceRange}`);
        }
        if (orderBy !== null) filters.push(`ordenar por:${orderBy}`);

        const viewListId = `${document.title.split(' | ')[0]}|F:${filters.length > 0 ? filters.join(',') : 'N/A'}`;

        setTimeout(() => {
          let itemCategory2 = '';
          const typeOfProduct = item.product_type;
          if (
            typeOfProduct == 'Anillos' ||
            typeOfProduct == 'Collares' ||
            typeOfProduct == 'Pendientes' ||
            typeOfProduct == 'Pulseras'
          ) {
            itemCategory2 = 'Bisutería';
          } else if (
            typeOfProduct == 'Bolsos' ||
            typeOfProduct == 'Bufandas' ||
            typeOfProduct == 'Calcetines' ||
            typeOfProduct == 'Calzado' ||
            typeOfProduct == 'Cinturones' ||
            typeOfProduct == 'Gafas' ||
            typeOfProduct == 'Gorros' ||
            typeOfProduct == 'Monederos'
          ) {
            itemCategory2 = 'Accesorios';
          } else if (typeOfProduct == 'Abrigos' || typeOfProduct == 'Gabardinas') {
            itemCategory2 = 'Abrigos y Gabardinas';
          } else if (typeOfProduct == 'Bañador' || typeOfProduct == 'Baño') {
            itemCategory2 = 'Baño';
          } else if (typeOfProduct == 'Blusas' || typeOfProduct == 'Camisas') {
            itemCategory2 = 'Camisas y Blusas';
          } else if (typeOfProduct == 'Camisetas') {
            itemCategory2 = 'Camisetas';
          } else if (typeOfProduct == 'Chalecos') {
            itemCategory2 = 'Chalecos';
          } else if (typeOfProduct == 'Kimonos' || typeOfProduct == 'Chaquetas') {
            itemCategory2 = 'Chaquetas y Kimonos';
          } else if (typeOfProduct == 'Faldas') {
            itemCategory2 = 'Faldas';
          } else if (typeOfProduct == 'Jerséis' || typeOfProduct == 'Cárdigans' || typeOfProduct == 'Ponchos') {
            itemCategory2 = 'Jerséis y Cárdigans';
          } else if (typeOfProduct == 'Pantalones') {
            itemCategory2 = 'Pantalones';
          } else if (typeOfProduct == 'Sudaderas') {
            itemCategory2 = 'Sudaderas';
          } else if (typeOfProduct == 'Tops') {
            itemCategory2 = 'Tops';
          } else if (typeOfProduct == 'Vaqueros') {
            itemCategory2 = 'Vaqueros';
          } else if (typeOfProduct == 'Vestidos' || typeOfProduct == 'Monos') {
            itemCategory2 == 'Vestidos y Monos';
          }

          let itemCategory = '';
          if (itemCategory2 == 'Accesorios') {
            itemCategory = 'Accesorios';
          } else if (itemCategory2 == 'Bisutería') {
            itemCategory = 'Bisutería';
          } else {
            itemCategory = 'Ropa';
          }

          gtag('event', 'add_to_cart', {
            event: 'add_to_cart',
            item_list_page: page,
            currency: 'EUR',
            event_category: 'ecommerce',
            item_list_name: viewListId,
            item_list_id: document.title.split(' | ')[0],
            items: [
              {
                item_id: item.product_id,
                item_name: item.product_title,
                quantity: 1,
                price: parseFloat(item.price / 100),
                discount: parseFloat(item.total_discount / 100) > 0 ? parseFloat(item.total_discount / 100) : 0,
                coupon: '',
                item_brand: 'renatta&go',
                item_category: itemCategory,
                item_category2: itemCategory2,
                item_category3: item.product_type,
                item_variant: item.variant_title.split(' / ')[0],
                affiliation: '',
                location_id: '',
                index: parseInt(index),
                item_list_name: viewListId,
                item_list_id: document.title.split(' | ')[0],
                promotion_name: sessionStorage.getItem('promotion_name') || '',
                promotion_id: sessionStorage.getItem('promotion_id') || '',
                img_articulo: item.image.split('https://cdn.shopify.com/s/')[1],
                color: item.variant_title.split(' / ')[1],
                precio_articulo: parseFloat(item.price / 100),
                descuento_artículo:
                  parseFloat(item.total_discount / 100) > 0 ? parseFloat(item.total_discount / 100) : 0,
                stock: stock,
                tallas_disponibles: availableSizes,
                tallas_no_disponibles: unavailableSizes,
                score_stock: scoreStock,
                modelo_artículo: model,
              },
            ],
          });
        }, 500);
        const cartItemCountTab = document
          .getElementById('cart-icon-bubble')
          .innerText.trim()
          .split('(')[1]
          .split(')')[0];
        const count = parseInt(cartItemCountTab, 10);
        const newCount = count + 1;
        if (newCount == 1) {
          let cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }
        }
        setTimeout(() => {
          document.getElementById('cart-items-count-tab').innerText = newCount;
        }, 2000);
      })
      .catch((error) => {
        console.error('Error al agregar al carrito:', error);
      });
  };

  const openCart = (data, eventTarget) => {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.drawer__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }

        // const cartItemCountTab = document.getElementById('cart-items-count-tab').innerText.trim();
        // const count = parseInt(cartItemCountTab, 10);
        // const newCount = count + 1;
        // document.getElementById('cart-items-count-tab').innerText = newCount;

        const cartItemCountTab = document
          .getElementById('cart-icon-bubble')
          .innerText.trim()
          .split('(')[1]
          .split(')')[0];
        const count = parseInt(cartItemCountTab, 10);
        const newCount = count + 1;

        setTimeout(() => {
          document.getElementById('cart-items-count-tab').innerText = newCount;
        }, 500);

        const cartIconBubbleElement = document.getElementById('cart-icon-bubble');
        const cartIconBubbleText = cartIconBubbleElement.innerText.trim();

        const matches = cartIconBubbleText.match(/(\D*)(\d+)(\D*)/);
        let countBubble = parseInt(matches[2], 10);
        countBubble += 1;
        const newCartIconBubble = `${matches[1]}${countBubble}${matches[3]}`;
        cartIconBubbleElement.innerText = newCartIconBubble;

        const completeYourLookContainer = document.querySelector('.complete_your_look-drawer_cart');
        if (completeYourLookContainer) {
          const links = completeYourLookContainer.querySelectorAll('a[data-hide-href]');
          links.forEach((link) => {
            const dataHideHref = link.getAttribute('data-hide-href');
            if (dataHideHref) {
              link.setAttribute('href', dataHideHref);
            }
          });

          const images = completeYourLookContainer.querySelectorAll('img[data-hide-src]');
          images.forEach((image) => {
            const dataHideImage = image.getAttribute('data-hide-src');
            const dataHideSrcSet = image.getAttribute('data-hide-srcset');
            if (dataHideImage) {
              image.setAttribute('src', dataHideImage);
              image.setAttribute('srcset', dataHideSrcSet);
            }
          });
        }
        productCardsSizes();
      })
      .catch((e) => {
        console.error(e);
      });

    // const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const cart = document.querySelector('cart-notification');

    setTimeout(() => {
      cart.classList.add('animate', 'active');
      cart.querySelector('#cart-notification').classList.add('active');

      document.body.addEventListener('click', (evt) => {
        const target = evt.target;
        if (target.nodeName == 'CART-NOTIFICATION' || target.className == 'cart-notification-wrapper') {
          cart.classList.remove('animate', 'active');
          cart.querySelector('#cart-notification').classList.remove('active');
          document.body.classList.remove('overflow-hidden');
        }
      });
    });

    if (cart.querySelector('.drawer__inner-empty')) cart.querySelector('.drawer__inner-empty').remove();
    if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

    const product = data.items[0];

    const productNotification = document.querySelector('#cart-notification-product');
    const productPriceEle = document
      .querySelector(`.grid__item[data-product-id="${product.product_id}"]`)
      ?.querySelector('.price');
    const productPreOrderEle = document
      .querySelector(`.grid__item[data-product-id="${product.product_id}"]`)
      ?.querySelector('.product-card-wrapper')
      ?.getAttribute('data-preorder');

    let priceHtml = '';
    if (productPriceEle) {
      priceHtml = productPriceEle.outerHTML;
    }

    let preorder = '';
    if (productPreOrderEle != null) {
      preorder = `
        <div class="product-option-preorder-wrapper">
          <div class="product-option-preorder">PRE-ORDER</div>
          <div class="product-option-preorder-content">${productPreOrderEle}</div>
        </div>
        <style>
          .cart-notification-content-wrapper {
            height: 100%;
            gap: 2rem;
          }
        </style>`;
    }

    productNotification.innerHTML = `
    <div id="cart-notification-product" class="cart-notification-product">
      <div class="cart-notification-product__image global-media-settings">
        <img src="${product.featured_image.url}" alt="" width="70" height="88" loading="lazy">
      </div>
      <div class="cart-notification-content-wrapper">
        ${preorder} 
        <div class="cart-notification-content"> 
          <h3 class="cart-notification-product__name h4">${product.title.split('-')[0]}</h3>
          ${priceHtml}    
          <div class="product-option">
            <dl>${product.variant_title}</dl>
          </div>
        </div>
      </div>
    </div>
    `;

    cart.querySelector('product-recommendations').setAttribute('data-product-id', product.product_id);

    const productRecommendations = cart.querySelector('product-recommendations');
    const sectionId = cart.querySelector('product-recommendations').getAttribute('data-section-id');
    const url = cart.querySelector('product-recommendations').getAttribute('data-url');
    const productId = cart.querySelector('product-recommendations').getAttribute('data-product-id');

    fetch(`${url}&product_id=${productId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          productRecommendations.innerHTML = recommendations.innerHTML;
        }

        if (
          !productRecommendations.querySelector('slideshow-component') &&
          productRecommendations.classList.contains('complementary-products')
        ) {
          productRecommendations.remove();
        }

        if (html.querySelector('.grid__item')) {
          productRecommendations.classList.add('product-recommendations--loaded');
        }

        productCardsSizes();
      })
      .catch((e) => {
        console.error(e);
      });

    // fetch(`${routes.cart_url}?section_id=cart-notification-product`)
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const html = new DOMParser().parseFromString(responseText, 'text/html');
    //     const selectors = ['cart-drawer-items', '.drawer__footer'];
    //     for (const selector of selectors) {
    //       const targetElement = document.querySelector(selector);
    //       const sourceElement = html.querySelector(selector);
    //       if (targetElement && sourceElement) {
    //         targetElement.replaceWith(sourceElement);
    //       }
    //     }

    //     const cartItemCountTab = document.getElementById('cart-items-count-tab').innerText.trim();
    //     const count = parseInt(cartItemCountTab, 10);
    //     const newCount = count + 1;
    //     document.getElementById('cart-items-count-tab').innerText = newCount;

    //     const cartIconBubbleElement = document.getElementById('cart-icon-bubble');
    //     const cartIconBubbleText = cartIconBubbleElement.innerText.trim();

    //     const matches = cartIconBubbleText.match(/(\D*)(\d+)(\D*)/);
    //     let countBubble = parseInt(matches[2], 10);
    //     countBubble += 1;
    //     const newCartIconBubble = `${matches[1]}${countBubble}${matches[3]}`;
    //     cartIconBubbleElement.innerText = newCartIconBubble;

    //     const completeYourLookContainer = document.querySelector('.complete_your_look-drawer_cart');
    //     if (completeYourLookContainer) {
    //         const links = completeYourLookContainer.querySelectorAll('a[data-hide-href]');
    //         links.forEach(link => {
    //             const dataHideHref = link.getAttribute('data-hide-href');
    //             if (dataHideHref) {
    //                 link.setAttribute('href', dataHideHref);
    //             }
    //         });

    //         const images = completeYourLookContainer.querySelectorAll('img[data-hide-src]');
    //         images.forEach(image => {
    //           const dataHideImage = image.getAttribute('data-hide-src');
    //           const dataHideSrcSet = image.getAttribute('data-hide-srcset')
    //           if (dataHideImage) {
    //             image.setAttribute('src', dataHideImage);
    //             image.setAttribute('srcset', dataHideSrcSet);
    //           }
    //       });
    //     }
    //     productCardsSizes();
    //   })
    //   .catch((e) => {
    //     console.error(e);
    //   });

    document.body.classList.add('overflow-hidden');
  };

  function productCardsSizes() {
    const productCardWrappers = document.querySelectorAll('.product-card-wrapper:not(.card__without-quickbuy)');

    productCardWrappers.forEach((productCard) => {
      productCard.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 750px)').matches) {
          productCard.classList.add('hovered');

          if (!productCard.classList.contains('is-executed')) {
            productCard.classList.add('is-executed');
            const productID = productCard.getAttribute('data-product');

            fetchCardProduct(productCard, productID);
          }
        }
      });

      productCard.addEventListener('mouseleave', () => {
        if (window.matchMedia('(min-width: 750px)').matches) {
          productCard.classList.remove('hovered');
          productCard.querySelector('.card__variants-sizes')?.remove();
          productCard.classList.remove('is-executed');
        }
      });

      productCard.querySelector('.card__sizes-opener')?.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 749px)').matches) {
          productCard.classList.remove('hovered');
          const productID = productCard.getAttribute('data-product');

          fetchCardProduct(productCard, productID);
        }
        setTimeout(() => {
          if (productCard.querySelectorAll('.card__size').length == 1) {
            productCard.querySelectorAll('.card__size')[0].click();
          }
        }, 1000);
      });

      const productColor = productCard.querySelectorAll('.color-dot');

      productColor.forEach((color) => {
        color.addEventListener('click', () => {
          fetchCardProductColors(color, productCard, true);
          const cardProductHandle = color.getAttribute('data-card-product');
          const productHandle = color.getAttribute('data-product');
          color.style.border = '.05rem solid rgba(0, 0, 0, 0.4);';
        });
      });
    });
  }

  const fetchCardProductColors = (color, productCard, coloChange) => {
    const productColorID = color.getAttribute('data-product');
    fetch(`${window.Shopify.routes.root}products/${productColorID}.js`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    })
      .then((response) => response.json())
      .then((product) => {
        const productID = product.handle;
        const productImage = product.featured_image;
        const productImageSrcsetValue = `${productImage}&width=165 165w, ${productImage}&width=360 360w, ${productImage}&width=533 533w, ${productImage}&width=720 720w, ${productImage}&width=940 940w, ${productImage} 960w`;

        const productImageSecond = product.media[1].src;
        const productImageSecondSrcsetValue = `${productImageSecond}&width=165 165w, ${productImageSecond}&width=360 360w, ${productImageSecond}&width=533 533w, ${productImageSecond}&width=720 720w, ${productImageSecond}&width=940 940w, ${productImageSecond} 960w`;

        fetchCardProduct(productCard, productID, coloChange);

        const activeColorDots = productCard.querySelectorAll('.color-dot.active');

        activeColorDots.forEach((colorDot) => {
          colorDot.classList.remove('active');
        });

        const targetProduct = product.handle;

        const colorDots = productCard.querySelectorAll('.color-dot');

        colorDots.forEach((colorDot) => {
          if (colorDot.getAttribute('data-product') === targetProduct) {
            colorDot.classList.add('active');
          }
        });

        productCard.querySelector('.card__information-heading .card__heading a').textContent = product.title;
        productCard.querySelector('.card__information-heading .card__heading a').href = product.url;
        productCard.querySelector('.card__inner a').href = product.url;
        
        productCard.querySelector('.card__media img.main-image').setAttribute('srcset', productImageSrcsetValue);
        productCard.querySelector('.card__media img.main-image').setAttribute('src', productImage);
        console.log(product);
        
        
        const priceEl = productCard.querySelector('.price');
        const priceRegularEl = priceEl.querySelector('.price__regular .price-item.price-item--regular');
        const priceSaleEl = priceEl.querySelector('.price__sale .price-item.price-item--regular');
        const comparePriceEl = priceEl.querySelector('.off-g-money');
        const discountEl = priceEl.querySelector('.off-g');
        const { compare_at_price, price, available } = product;

        if (!priceEl.classList.contains('price--private-sale')) {

          priceEl?.classList.toggle('price--sold-out', !available);
          priceEl?.classList.toggle('price--on-sale', compare_at_price > price);
          
          if (priceRegularEl && !(compare_at_price > price)) {
            const formatCurrency = (value) => {
              return new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(value).replace(/\s+/g, '');;
            };
            
            let displayValue = price;
            if (typeof price === 'number') {
              displayValue = price >= 1000 ? price / 100 : price;
              priceRegularEl.textContent = formatCurrency(displayValue);
              priceSaleEl.textContent = formatCurrency(displayValue);
            } else {
              priceRegularEl.textContent = String(price);
              priceSaleEl.textContent = String(price);
            }
          }
          
          if (comparePriceEl && compare_at_price > price) {
            const formatCurrency = (value, locale = 'es-ES', currency = 'EUR') => {
              return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(value).replace(/\s+/g, '');
            };
            
            let displayValuePrice = price;
            if (typeof price === 'number') {
              displayValuePrice = price >= 1000 ? price / 100 : price;
              comparePriceEl.textContent = formatCurrency(displayValuePrice);
            } else {
              comparePriceEl.textContent = String(price);
            }
            
            let displayValue = compare_at_price;
            if (typeof compare_at_price === 'number') {
              displayValue = compare_at_price >= 1000 ? compare_at_price / 100 : compare_at_price;
              priceRegularEl.textContent = formatCurrency(displayValue);
              priceSaleEl.textContent = formatCurrency(displayValue);
            } else {
              priceRegularEl.textContent = String(compare_at_price);
              priceSaleEl.textContent = String(compare_at_price);
            }
            
            if (discountEl && typeof compare_at_price === 'number' && typeof price === 'number') {
              const discountPercentage = Math.floor(((compare_at_price - price) * 100) / compare_at_price);
              discountEl.textContent = `${discountPercentage}% OFF`;
            }
            
          }
        }


        if (productCard.querySelector('.card__media img.second-image'))
          productCard
            .querySelector('.card__media img.second-image')
            .setAttribute('srcset', productImageSecondSrcsetValue);
        if (productCard.querySelector('.card__media img.second-image'))
          productCard.querySelector('.card__media img.second-image').setAttribute('src', productImageSecond);

        productCard.setAttribute('data-product', product.handle);

        const productGif = window.productMetafield_gif_plp[product.id];

        if (productGif) {
          if (productGif?.includes('.gif')) {
            productCard.querySelector('.card__media .has-gift-plp').setAttribute('srcset', productGif);
            productCard.querySelector('.card__media .has-gift-plp').setAttribute('src', productGif);
          } else {
            setTimeout(() => {
              const videoSource = productCard.querySelector('.card__media video.has-gift-plp source');
              const videoElement = productCard.querySelector('.card__media video.has-gift-plp');

              // Detener el video actual antes de cambiar el src
              videoElement.pause();
              videoElement.currentTime = 0; // Volver al principio del video

              // Cambiar el src del source
              videoSource.setAttribute('src', productGif);

              // Recargar el video
              videoElement.load();

              // Reproducir el video si se desea
              videoElement.play();

              const allSlides = productCard.querySelector('.swiper-container').querySelectorAll('.swiper-slide');

              if (allSlides) {
                allSlides.forEach((slide, index) => {
                  if (index !== 0) {
                    const rightIndex = index + 1;
                    if (product.media[index]) {
                      // Verificar si existe la imagen correspondiente

                      const productImageSlide = product.media[index].src;
                      const productImageSrcsetValueSlide = `${productImageSlide}&width=165 165w, ${productImageSlide}&width=360 360w, ${productImageSlide}&width=533 533w, ${productImageSlide}&width=720 720w, ${productImageSlide}&width=940 940w, ${productImageSlide} 960w`;


                      const imgElement = slide.querySelector(`img.slide-${rightIndex}`);
                      if (imgElement) {
                        imgElement.setAttribute('srcset', productImageSrcsetValueSlide);
                        imgElement.setAttribute('src', productImageSlide);
                        imgElement.currentSrc = productImageSlide;
                        imgElement.dataset.hideSrc = productImageSlide;
                        slide.classList.remove('hidden');
                      }
                    } else {
                      // Si no hay imagen correspondiente, ocultamos el slide
                      slide.classList.add('hidden');
                    }
                  }
                });
              }
            }, 250);
          }
          productCard.querySelector('.card__media .has-gift-plp').classList.remove('hidden');
        } else {
          if (productCard.querySelector('.card__media video.has-gift-plp')) {
            productCard.querySelector('.card__media video.has-gift-plp').classList.add('hidden');
            productCard.querySelector('.card__media img.main-image').setAttribute('srcset', productImageSrcsetValue);
            productCard.querySelector('.card__media img.main-image').setAttribute('src', productImage);

            const allSlides = productCard.querySelector('.swiper-container').querySelectorAll('.swiper-slide');

            if (allSlides) {
              allSlides.forEach((slide, index) => {
                if (index !== 0) {
                  const rightIndex = index + 1;
                  if (product.media[index]) {
                    // Verificar si existe la imagen correspondiente

                    const productImageSlide = product.media[index].src;
                    const productImageSrcsetValueSlide = `${productImageSlide}&width=165 165w, ${productImageSlide}&width=360 360w, ${productImageSlide}&width=533 533w, ${productImageSlide}&width=720 720w, ${productImageSlide}&width=940 940w, ${productImageSlide} 960w`;


                    const imgElement = slide.querySelector(`img.slide-${rightIndex}`);
                    if (imgElement) {
                      imgElement.setAttribute('srcset', productImageSrcsetValueSlide);
                      imgElement.setAttribute('src', productImageSlide);
                      imgElement.currentSrc = productImageSlide;
                      imgElement.dataset.hideSrc = productImageSlide;
                    }
                  } else {
                    // Si no hay imagen correspondiente, ocultamos el slide
                    slide.classList.add('hidden');
                  }
                }
              });
            }
          } else {

            //productCard.querySelectorAll('.card__media .main-image')[1].classList.add('hidden');
            const allSlides = productCard.querySelector('.swiper-container').querySelectorAll('.swiper-slide');

            if (allSlides) {
              allSlides.forEach((slide, index) => {
                if (index !== 0) {
                  const rightIndex = index + 1;
                  if (product.media[index]) {
                    // Verificar si existe la imagen correspondiente

                    const productImageSlide = product.media[index].src;
                    const productImageSrcsetValueSlide = `${productImageSlide}&width=165 165w, ${productImageSlide}&width=360 360w, ${productImageSlide}&width=533 533w, ${productImageSlide}&width=720 720w, ${productImageSlide}&width=940 940w, ${productImageSlide} 960w`;


                    const imgElement = slide.querySelector(`img.slide-${rightIndex}`);
                    if (imgElement) {
                      imgElement.setAttribute('srcset', productImageSrcsetValueSlide);
                      imgElement.setAttribute('src', productImageSlide);
                      imgElement.currentSrc = productImageSlide;
                      imgElement.dataset.hideSrc = productImageSlide;
                      slide.classList.remove('hidden');
                    }
                  } else {
                    // Si no hay imagen correspondiente, ocultamos el slide
                    slide.classList.add('hidden');
                  }
                }
              });
            }
            if (productGif) {
              productCard.querySelectorAll('.card__media .main-image')[0].setAttribute('srcset', productGif);
              productCard.querySelectorAll('.card__media .main-image')[0].setAttribute('src', productGif);

              const allSlides = productCard.querySelector('.swiper-container').querySelectorAll('.swiper-slide');

              if (allSlides) {
                allSlides.forEach((slide, index) => {
                  if (index !== 0) {
                    const rightIndex = index + 1;
                    if (product.media[index]) {
                      // Verificar si existe la imagen correspondiente

                      const productImageSlide = product.media[index].src;
                      const productImageSrcsetValueSlide = `${productImageSlide}&width=165 165w, ${productImageSlide}&width=360 360w, ${productImageSlide}&width=533 533w, ${productImageSlide}&width=720 720w, ${productImageSlide}&width=940 940w, ${productImageSlide} 960w`;


                      const imgElement = slide.querySelector(`img.slide-${rightIndex}`);
                      if (imgElement) {
                        imgElement.setAttribute('srcset', productImageSrcsetValueSlide);
                        imgElement.setAttribute('src', productImageSlide);
                        imgElement.currentSrc = productImageSlide;
                        imgElement.dataset.hideSrc = productImageSlide;
                        slide.classList.remove('hidden');
                      }
                    } else {
                      // Si no hay imagen correspondiente, ocultamos el slide
                      slide.classList.add('hidden');
                    }
                  }
                });
              }
            }
          }
        }
      });
  };

  productCardsSizes();
}
